<div class="tooltip" [style.left.px]="left" [style.top.px]="top">
    <ng-container *ngFor="let item of tooltip">
        <a [href]="item?.url" target="_blank">{{ item?.name }}</a>
    </ng-container>
</div>
